const latin = {
  // Branding
  app_name: "Terakki",

  // Auth — common
  email: "Email",
  password: "Parola",
  password_confirm: "Parola (Tekrar)",
  name: "Ad",
  surname: "Soyad",
  back: "Geri",
  next: "İleri",
  submit: "Gönder",

  // Login
  auth_welcome: "HOŞ GELDİNİZ",
  auth_brand_tagline: "TERAKKİ PANELİ",
  auth_brand_description:
    "Günlük okumalarını kaydet, hatimlerini takip et ve cemaatinle birlikte adım adım ilerle.",
  auth_back_to_site: "Siteye dön",
  login_subtitle: "Hesabınıza giriş yapın.",
  password_show: "GÖSTER",
  password_hide: "GİZLE",
  login_title: "Giriş Yap",
  login_submit: "Giriş Yap",
  login_forgot_password: "Şifremi unuttum",
  login_no_account: "Hesabın yok mu?",
  login_signup_link: "Kayıt ol",
  login_error_invalid: "Email veya şifre hatalı.",
  login_error_locked: "Çok fazla başarısız deneme. {minutes} dk sonra tekrar deneyin.",
  login_error_generic: "Giriş yapılamadı. Lütfen tekrar deneyin.",
  signup_error: "Kayıt oluşturulamadı. Lütfen bilgilerinizi kontrol edip tekrar deneyin.",
  verify_error: "Doğrulama kodu hatalı ya da süresi dolmuş. Lütfen tekrar deneyin.",
  verify_success: "Email adresiniz doğrulandı.",
  verify_success_login: "Email adresiniz doğrulandı. Şimdi giriş yapabilirsiniz.",
  verify_code_sent: "Yeni doğrulama kodu email adresinize gönderildi.",
  verify_code_send_error: "Doğrulama kodu gönderilemedi. Lütfen tekrar deneyin.",

  // Signup
  signup_title: "Kayıt Ol",
  signup_step_who: "Sen kimsin?",
  signup_step_account: "Hesap bilgileri",
  signup_step_verify: "E-postanı doğrula",
  signup_continue: "Devam",
  signup_back: "Geri",
  signup_submit: "Kod Gönder",
  signup_already_have_account: "Hesabın var mı?",
  signup_login_link: "Giriş yap",

  // Email verify
  verify_title: "Email Doğrulama",
  verify_subtitle: "{email} adresine gönderilen 6 haneli kodu girin",
  verify_code: "Doğrulama Kodu",
  verify_submit: "Doğrula",
  verify_resend: "Kodu tekrar gönder",
  verify_resend_in: "{seconds}sn sonra tekrar gönderebilirsin",

  // Forgot password
  forgot_title: "Şifremi Unuttum",
  forgot_submit: "Sıfırlama Linki Gönder",
  forgot_success: "Eğer bu email kayıtlıysa şifre sıfırlama linki gönderildi.",
  forgot_back_to_login: "Girişe dön",

  // Validation
  validation_required: "Bu alan zorunlu.",
  validation_email: "Geçerli bir email adresi girin.",
  validation_password_min: "En az 8 karakter olmalı.",
  validation_password_match: "Parolalar eşleşmiyor.",
  validation_code_length: "6 haneli kodu girin.",

  // Common UI
  loading: "Yükleniyor...",
  empty_state: "Burada henüz bir şey yok.",
  retry: "Tekrar dene",
  close: "Kapat",
  save: "Kaydet",
  cancel: "İptal",
  delete: "Sil",
  edit: "Düzenle",
  remove_row: "Satırı kaldır",
  day_prev: "Önceki gün",
  day_next: "Sonraki gün",
  confirm: "Onayla",

  // Ortak hata mesajları — apiErrorMessage.js bunları kullanıyor
  error_generic: "İşlem tamamlanamadı. Lütfen tekrar deneyin.",
  error_network: "İnternet bağlantısı kurulamadı. Bağlantınızı kontrol edip tekrar deneyin.",
  error_timeout: "Sunucu zamanında yanıt vermedi. Lütfen tekrar deneyin.",
  error_server: "Sunucuda bir sorun oluştu. Lütfen birkaç dakika sonra tekrar deneyin.",
  error_session_expired: "Oturumunuzun süresi doldu. Lütfen tekrar giriş yapın.",
  error_forbidden: "Bu işlem için yetkiniz yok.",
  error_not_found: "Aradığınız kayıt bulunamadı.",
  error_rate_limited: "Çok fazla deneme yaptınız. Lütfen biraz bekleyip tekrar deneyin.",
  error_invalid_form: "Girdiğiniz bilgiler geçersiz. Lütfen alanları kontrol edip tekrar deneyin.",
  error_hatim_not_found: "Hatim kaydı bulunamadı.",
  error_qr_template_not_found: "QR şablonu bulunamadı.",

  // Maintenance
  maintenance_title: "Bakım Modu",
  maintenance_message: "Sistem geçici olarak kullanılamıyor. Lütfen birkaç dakika sonra tekrar deneyin.",

  // Nav (SideNav) — Faz 1 active
  nav_profile: "Terakkim",
  menu_profile: "Profil",
  nav_settings: "Ayarlar",
  nav_logout: "Çıkış Yap",
  // Nav — Faz 2+ disabled placeholders
  nav_results: "Sonuçlar",
  nav_hatim: "Hatim",
  nav_groups: "Grup Yönetimi",
  nav_hatim_management: "Hatim Yönetimi",
  nav_notifications: "Duyurular",
  nav_my_goals: "Hedeflerim",
  nav_personal_stats: "Kişisel İstatistik",
  nav_my_groups: "Gruplarım",
  nav_section_tracking: "Takibim",
  nav_section_manage: "Yönetim",
  nav_section_community: "Topluluk",
  // Terakki Yönetimi (Admin) menüsü
  nav_admin_section: "Terakki Yönetimi",
  nav_admin_dashboard: "Sistem Panosu",
  nav_admin_library: "Kütüphane Denetimi",
  nav_admin_users: "Kullanıcılar",
  nav_admin_announcements: "Duyurular",
  nav_admin_audit: "Denetim Kayıtları",
  notif_page_title: "Duyurular",
  notif_send_heading: "Yeni duyuru",
  notif_target_label: "Grup",
  notif_target_all: "Herkes",
  notif_target_placeholder: "Grup seçin",
  notif_target_hint: "Birden fazla seçebilirsiniz.",
  notif_target_groups: "Gruplarım",
  notif_target_hatims: "Hatimlerim",
  notif_target_unknown: "Silinmiş",
  notif_target_none: "Hiç grup seçilmedi",
  notif_target_selected: "seçili",
  notif_target_clear: "Seçimi temizle",
  notif_target_empty: "Yönettiğiniz bir grup veya hatim yok.",
  notif_history_to: "Hedef",
  notif_send_partial: "Bazı duyurular gönderilemedi:",
  notif_send_count: "duyuru gönderildi.",
  notif_title_label: "Başlık",
  notif_body_label: "Mesaj",
  notif_submit: "Gönder",
  notif_sending: "Gönderiliyor…",
  notif_send_error: "Duyuru gönderilemedi.",
  notif_history_heading: "Gönderim geçmişi",
  notif_history_empty: "Henüz duyuru gönderilmedi.",
  notif_history_load_error: "Gönderim geçmişi yüklenemedi. Lütfen tekrar deneyin.",
  notif_history_retry: "Tekrar dene",
  notif_status_pending: "Sırada",
  notif_status_sending: "Gönderiliyor",
  notif_status_done: "Gönderildi",
  notif_status_failed: "Başarısız",
  notif_kind_announcement: "Duyuru",
  notif_kind_hatim_assigned: "Hatim ataması",
  notif_kind_group_joined: "Gruba eklenme",
  notif_kind_goal_updated: "Hedef değişikliği",
  notif_kind_hatim_period: "Yeni hatim dönemi",
  notif_devices: "cihaz",
  notif_dev_heading: "Kayıtlı cihazlar",
  notif_dev_active: "Aktif",
  notif_dev_inactive: "Pasif",
  notif_dev_ios: "iPhone",
  notif_dev_android: "Android",
  notif_dev_last_seen: "Son görülen",
  notif_dev_none: "Henüz kayıtlı cihaz yok.",
  notif_dev_hint: "Kullanıcı uygulamayı açıp bildirim izni verdiğinde cihazı burada görünür.",
  notif_dev_inactive_hint: "Pasif cihazlar uygulamayı silmiş ya da bildirimi kapatmış kullanıcılardır.",
  notif_stat_recipients: "Hedeflenen",
  notif_stat_failed: "Ulaşmayan",
  notif_error_label: "Hata",
  nav_manage: "Yönetim",
  nav_stats: "İstatistik",
  nav_coming_soon: "Yakında",

  // Profile page
  profile_title: "Profilim",
  profile_week_summary: "Bu hafta özeti",
  profile_streak: "Günlük seri",
  profile_perfect_days: "Mükemmel gün",
  profile_completion: "Tamamlanan hedef",
  profile_account_settings: "Hesap Ayarları",
  profile_edit_info: "Profil bilgilerini düzenle",
  profile_edit_info_short: "Bilgileri Düzenle",
  profile_change_password: "Şifre değiştir",
  profile_script_mode: "Görünüm dili (Latin / Osmanlıca)",
  profile_delete_account: "Hesabı sil",
  profile_delete_confirm_title: "Hesabınızı silmek istediğinize emin misiniz?",
  profile_delete_confirm_body: "Bu işlem geri alınamaz. Tüm verileriniz kalıcı olarak silinecek.",
  profile_delete_confirm_phrase: "Onaylamak için 'SIL' yazın:",
  profile_verified: "Email doğrulandı",
  profile_danger_zone: "Tehlikeli bölge",
  profile_field_fullname: "Ad Soyad",
  profile_field_email: "E-posta",
  profile_field_role: "Rol",
  profile_field_joined: "Üyelik tarihi",
  profile_field_password: "Şifre",
  profile_my_goals: "Hedeflerim",
  profile_goal_target: "Hedef",
  profile_my_groups: "Gruplarım",
  profile_group_count: "Üye olduğunuz grup sayısı",
  role_user: "Üye",
  role_admin: "Sistem Yöneticisi",
  profile_edit_info_desc: "Ad ve soyadınızı güncelleyin.",
  profile_change_password_desc: "Hesabınızın parolasını değiştirin.",
  profile_delete_account_desc: "Hesabınızı ve tüm verilerinizi kalıcı olarak silin.",
  profile_update_success: "Profil bilgileriniz güncellendi.",
  profile_update_error: "Profil bilgileriniz güncellenemedi. Lütfen tekrar deneyin.",
  password_change_success: "Parolanız güncellendi.",
  password_change_error: "Parolanız güncellenemedi. Lütfen tekrar deneyin.",
  account_delete_success: "Hesabınız silindi.",
  account_delete_error: "Hesabınız silinemedi. Lütfen tekrar deneyin.",

  // TopBar
  topbar_user_menu: "Kullanıcı Menüsü",

  // Days/months (subset — full set in Faz 2)

  // Faz 2 — Results page
  results_title: "İlerlemelerim",
  results_today: "Bugün",
  results_yesterday: "Dün",
  results_tomorrow: "Yarın",
  results_pick_date: "Tarih seç",
  results_my_goals: "Hedeflerim",
  results_completion_today: "Bugün",
  results_no_goals: "Henüz bir hedef yok. 'Hedef ekle / düzenle' ile ekleyebilirsin.",
  results_add_edit_goals: "Hedef ekle / düzenle",
  results_notes_events: "Notlar & Olaylar",
  results_event_title: "Başlık",
  results_event_description: "Açıklama",
  results_event_add: "Ekle",
  results_save: "Kaydet",
  results_save_success: "Kaydedildi",
  results_save_failed: "Kaydedilemedi. Lütfen tekrar deneyin.",
  results_target_label: "/ {target}",

  // Goal management modal
  goal_modal_title: "Kişisel Hedeflerim",
  goal_modal_subtitle: "Buradaki hedefler sadece sizin profilinize bağlıdır. Gruptan gelen hedefler burada görünmez.",
  goal_modal_add_button: "Yeni hedef ekle",
  goal_modal_label_field: "Hedef adı",
  goal_modal_value_field: "Hedef değer",
  goal_modal_empty: "Henüz kişisel hedef eklemedin.",
  goal_modal_added: "Hedef eklendi.",
  goal_modal_updated: "Hedef güncellendi.",
  goal_modal_deleted: "Hedef silindi.",
  goal_modal_error: "Hedef işlemi tamamlanamadı. Lütfen tekrar deneyin.",

  // Statistics page
  stats_title: "Kişisel İstatistik",
  stats_current_streak: "Günlük seri",
  stats_longest_streak: "En uzun seri",
  stats_perfect_days: "Tam gün",
  stats_completion_rate: "Tamamlama (30 gün)",
  stats_unit_days: "gün",
  stats_unit_percent: "%",
  stats_chart_30day_title: "Son 30 gün — günlük tamamlama oranı",
  stats_month_title: "Bu ay",
  stats_goal_summary_title: "Hedef bazlı özet (son 30 gün)",
  stats_goal_summary_label: "Hedef",
  stats_goal_summary_total: "Toplam",
  stats_goal_summary_avg: "Ortalama / gün",
  stats_goal_summary_completion: "Tamamlama %",
  stats_no_data: "Henüz yeterli veri yok.",
  stats_subtitle: "Gidişatın, hedeflerin ve ayların bir bakışta.",
  stats_pick_month: "Ay seç",
  stats_perfect_last30: "son 30 günde {count}",
  stats_completion_hint: "Son 30 gün, boş günler dahil",
  stats_trend_title: "Son 30 gün",
  stats_trend_subtitle: "Günlük tamamlama oranı",
  stats_week_title: "Son 7 gün",
  stats_week_subtitle: "★ tam gün",
  stats_goals_title: "{month} hedefleri",
  stats_goals_subtitle: "O ay geçerli olan bütün hedefler, o günlerin hedefleriyle",
  stats_monthly_title: "Aylık gidiş",
  stats_monthly_subtitle: "Ortalama tamamlama; çubuğa basınca o ay seçilir",
  stats_calendar_subtitle: "Günlük kayıtlar",

  // Calendar
  calendar_legend_complete: "Mükemmel",
  calendar_legend_perfect: "Tam gün",
  calendar_legend_partial: "Kısmi",
  calendar_legend_missed: "Eksik",
  calendar_legend_empty: "Veri yok",

  // Takvim paneli
  calendar_prev_month: "Önceki ay",
  calendar_next_month: "Sonraki ay",
  calendar_month_summary: "Ay özeti",
  calendar_month_fill: "Kayıt tutulan gün oranı",
  calendar_summary_logged: "Kayıtlı gün",
  calendar_summary_stars: "Yıldız",
  calendar_summary_chain: "En uzun zincir",
  calendar_summary_average: "Ortalama",
  calendar_selected_day: "Seçili gün",
  calendar_perfect_day: "Tam gün",
  calendar_chain: "Zincir",
  calendar_chain_unit: "gün",
  calendar_goals_done: "hedef tamam",
  goal_complete: "Hedefi tamamla",
  goal_decrease: "Azalt",
  goal_increase: "Artır",
  goal_value: "Hedef değeri",
  calendar_saved: "Kaydedildi",
  calendar_future_day: "Gelecek bir gün, kayıt girilemez.",
  calendar_hatim_of_month: "Bu ayki hatimleriniz",
  calendar_no_hatim: "Bu ay katıldığınız bir hatim yok.",
  hatim_my_title: "Hatimlerim",
  calendar_no_hatim_day: "Seçili gün için hatim yok.",
  hatim_finished: "Süresi doldu",
  hatim_days_left: "gün kaldı",
  hatim_hours_left: "saat kaldı",
  hatim_minutes_left: "dakika kaldı",
  hatim_locked_completed: "Bu hatim tamamlandı, ilerleme değiştirilemez.",
  hatim_locked_passed: "Süresi geçtiği için ilerleme değiştirilemez.",
  hatim_pages_unit: "sayfa",
  hatim_pick_ranges: "Tamamladığınız sayfa aralıklarını seçin:",
  hatim_no_assigned_ranges: "Atanmış sayfa aralığınız bulunmuyor.",
  hatim_join_cta: "Katıl",
  hatim_join_drawer_subtitle: "Kodla hatime katılın",
  join_step_label: "adım",
  join_step_code_title: "Katılım kodu",
  join_step_code_desc: "Hatim yöneticinizin paylaştığı 8 haneli katılım kodunu sırasıyla kutulara girin. Tüm haneler dolduğunda hatim bilgileri yüklenecektir.",
  join_step_share_title: "Payınızı seçin",
  join_step_share_desc_range: "Bu hatimde okuyacağınız bölümü seçin. Her cüz 20 sayfadır. Birden fazla seçim yapabilirsiniz; başkalarının aldığı bölümler listede görünmez.",
  join_step_share_desc_amount: "Bu hatimde kaç adet okuyacağınızı belirtin. Örneğin Yasin hatiminde okuyacağınız Yasin-i Şerif sayısı. En az 1 girmeniz gerekmektedir.",
  join_step_confirm_title: "Tamamla",
  join_step_confirm_desc: "Seçimlerinizi kontrol edin. Onayladığınızda bu hatimin katılımcılarından olacak ve okumalarınızı Hatim listenizden takip edebileceksiniz.",
  hatim_join_selected_total: "Seçilen toplam",
  hatim_join_pick_blocks: "Almak istediğiniz sayfa bloklarını seçin:",
  hatim_join_no_blocks: "Bu hatimde boş sayfa bloğu kalmamış.",
  hatim_join_confirm_hint: "Seçimlerinizi kontrol edin, onayladığınızda hatime katılacaksınız.",
  hatim_join_summary_name: "Hatim",
  hatim_join_summary_type: "Tür",
  hatim_join_summary_share: "Payınız",
  hatim_join_summary_ranges: "Sayfa aralıkları",

  // Profile page additions
  profile_this_month: "Bu ay",
  profile_open_results: "İlerlemeler",

  // Faz 3 — Gruplarım
  groups_title: "Gruplarım",
  groups_join_cta: "Gruba Katıl",
  groups_empty_title: "Henüz gruba dahil değilsin",
  groups_empty_body: "Bir yöneticiden davet kodu veya link aldığında buradan katılabilirsin.",
  groups_empty_cta: "Gruba Katıl",
  groups_role_member: "Üye",
  groups_role_manager: "Yönetici",
  groups_member_count: "üye",
  groups_count_suffix: "grup",
  groups_create_cta: "Yeni Grup",
  groups_add_member_cta: "Üye Ekle",
  groups_add_manager_cta: "Yönetici Ekle",
  groups_manager_badge: "Yönetici",
  groups_empty: "Henüz bir gruba katılmadınız.",
  groups_manage_empty: "Henüz yönettiğiniz bir grup yok. Yeni grup oluşturabilirsiniz.",
  groups_pick_hint: "Detayları görmek için soldan bir grup seçin.",
  groups_tab_people: "Kişiler",
  groups_tab_goals: "Hedefler",
  groups_tab_progress: "İlerleme",
  groups_tab_settings: "Ayarlar",
  groups_tab_overview: "Genel",
  groups_goals_hint: "Bir üyenin yanındaki hedef düğmesiyle o üyeye grup hedefi ekleyebilir, güncelleyebilir veya silebilirsiniz.",
  groups_goals_drawer_subtitle: "Grup hedeflerini düzenleyin",
  manage_section_group_goals: "Grup hedefleri",
  manage_goals_current: "Şu anki hedef",
  groups_delete_hint: "Grubu silmek geri alınamaz.",
  groups_delete_requires_empty: "Grup silinebilmesi için grupta hiç üye kalmamalıdır. Şu an {n} üye var; önce hepsini çıkarın.",
  groups_delete_requires_creator: "Grubu yalnızca oluşturan kişi silebilir.",
  groups_leave_hint: "Gruptan ayrıldığınızda grup hedefleriniz kaldırılır.",
  groups_member_view_hint: "Üye listesi yalnızca grup yöneticilerine gösterilir.",
  manage_stats_empty: "Seçili tarih aralığında kayıt bulunamadı.",
  manage_stats_members_title: "Üye ilerlemesi",
  manage_stats_remove_member: "Gruptan çıkar",
  report_cta: "Rapor Al",
  report_title: "Grup İlerleme Raporu",
  report_printed_at: "Rapor tarihi",
  report_building: "Rapor hazırlanıyor...",
  report_error: "Rapor oluşturulamadı. Lütfen tekrar deneyin.",
  report_download: "PDF İndir",
  report_download_png: "PNG İndir",
  report_png_error: "PNG oluşturulamadı. Lütfen tekrar deneyin.",
  report_share: "Paylaş",
  report_share_error: "Paylaşım tamamlanamadı.",
  report_share_unsupported: "Bu tarayıcı dosya paylaşımını desteklemiyor; raporu indirebilirsiniz.",
  report_col_goal: "Hedef",
  report_col_value: "Değer",
  report_col_total: "Toplam",
  report_col_active_days: "Aktif Gün",
  report_col_perfect_days: "Tam Gün",
  report_col_completion: "Tamamlama",
  manage_stats_sort_label: "Sırala",
  manage_stats_range_label: "Tarih aralığı",
  manage_stats_presets_label: "Hazır aralıklar",
  manage_stats_custom_range_label: "Kendin seç",
  manage_stats_range_hint: "Hazır bir aralık seçebilir ya da tarihleri elle girebilirsiniz.",
  manage_stats_member_labels: "Hedef bazında",
  groups_manager_count: "yönetici",
  groups_joined_prefix: "katıldın",
  groups_load_error: "Grup listeniz yüklenemedi. Lütfen tekrar deneyin.",
  groups_retry: "Tekrar dene",

  group_back_to_list: "◀ Gruplarım",
  group_description_title: "Açıklama",
  group_no_description: "Bu grubun açıklaması yok.",
  group_quick_info_title: "Hızlı bilgi",
  group_quick_info_member_label: "Üye sayısı",
  group_quick_info_manager_label: "Yönetici",
  group_quick_info_created_label: "Kuruluş",
  group_managers_section_title: "Yöneticiler",
  group_hatim_section_title: "Bu grupta hatim takibi",
  group_hatim_section_body: "Hatim takibi mobilde aktif. Web yönetimi sonraki fazlarda gelecek.",
  group_coming_soon: "Yakında",
  group_leave_cta: "Gruptan Ayrıl",
  group_not_found: "Bu gruba artık erişimin yok.",

  group_leave_confirm_title: "Gruptan ayrılmak istediğine emin misin?",
  group_leave_confirm_body: "Bu grubun günlük amellerine artık erişemezsin. İstediğinde tekrar davet alarak katılabilirsin.",
  group_leave_confirm_cancel: "Vazgeç",
  group_leave_confirm_confirm: "Ayrıl",
  group_leave_success: "Gruptan ayrıldın",
  group_leave_error: "Gruptan ayrılma işlemi tamamlanamadı. Lütfen tekrar deneyin.",

  group_join_modal_title: "Gruba Katıl",
  group_join_input_label: "Davet kodu veya bağlantı",
  group_join_placeholder: "Kod veya bağlantı yapıştır...",
  group_join_help: "Bir yöneticiden aldığın davet kodu veya bağlantıyı yapıştır.",
  group_join_detected: "Davet algılandı",
  group_join_lookup_failed: "Bu davet koduna ait grup bulunamadı. Kodu kontrol edip tekrar deneyin.",
  group_join_parse_error: "Geçerli bir davet kodu veya linki yapıştırın.",
  group_join_confirm_cta: "Katıl",
  group_join_cancel: "Vazgeç",
  group_join_already_member: "Zaten bu grubun üyesisin",
  group_join_success: "{groupName} grubuna katıldın",
  group_join_error: "Gruba katılma işlemi tamamlanamadı. Lütfen tekrar deneyin.",

  // Faz 4 — Yönetim
  manage_title: "Yönetim",
  manage_create_cta: "+ Yeni Grup",
  manage_empty_title: "Henüz yönettiğin bir grup yok",
  manage_empty_body: "Bir grup oluşturduğunda burada listelenecek.",
  manage_empty_cta: "Grup Oluştur",
  manage_card_template_count: "şablon",
  manage_load_error: "Yönettiğiniz gruplar yüklenemedi. Lütfen tekrar deneyin.",
  manage_retry: "Tekrar dene",

  manage_create_modal_title: "Yeni Grup",
  manage_create_name_label: "Grup adı",
  manage_create_description_label: "Açıklama (opsiyonel)",
  manage_create_submit: "Oluştur",
  manage_create_cancel: "Vazgeç",
  manage_create_success: "Grup oluşturuldu",
  manage_create_error: "Grup oluşturulamadı. Lütfen tekrar deneyin.",

  manage_detail_back: "◀ Yönetim",
  manage_detail_rename: "✏ Adı Değiştir",
  manage_detail_save: "Kaydet",
  manage_detail_cancel: "Vazgeç",
  manage_rename_success: "Ad güncellendi",
  manage_rename_error: "Grup adı güncellenemedi. Lütfen tekrar deneyin.",
  manage_detail_load_error: "Grup bilgileri yüklenemedi. Lütfen tekrar deneyin.",

  manage_section_members: "Üyeler",
  manage_section_managers: "Yöneticiler",
  manage_section_templates: "QR Şablonları",
  manage_add_member_cta: "+ Üye Ekle",
  manage_add_manager_cta: "+ Yönetici Ekle",
  manage_add_template_cta: "+ Yeni Şablon",

  manage_add_person_modal_title_member: "Üye Ekle",
  manage_add_person_modal_title_manager: "Yönetici Ekle",
  manage_add_person_email_label: "Email",
  manage_add_person_submit: "Ekle",
  manage_add_person_cancel: "Vazgeç",
  manage_add_person_error: "Kişi gruba eklenemedi. Lütfen tekrar deneyin.",
  manage_add_person_code_label: "Kişinin kodu",
  manage_add_person_code_help: "Kişinin uygulamada yan menüde gördüğü 8 haneli kod",
  manage_member_added: "Üye eklendi",
  manage_manager_added: "Yönetici eklendi",

  manage_remove_person_confirm_title: "Bu kişiyi kaldır?",
  manage_remove_person_confirm_body: "Bu kişiyi gruptan kaldırmak üzeresin.",
  manage_remove_person_cta: "Kaldır",
  manage_remove_person_cancel: "Vazgeç",
  manage_member_removed: "Üye çıkarıldı",
  manage_manager_removed: "Yönetici çıkarıldı",
  manage_remove_error: "Kişi gruptan çıkarılamadı. Lütfen tekrar deneyin.",

  manage_self_label: "Sen",
  manage_self_cant_remove: "Kendini bu listeden kaldıramazsın",
  manage_managers_empty: "Henüz yönetici yok",
  manage_members_empty: "Henüz üye yok",

  manage_template_goal_count: "{count} hedef",
  manage_template_share_cta: "📋 Davet Paylaş",
  manage_template_delete_cta: "🗑 Sil",
  manage_template_empty_title: "Henüz QR şablonu yok",
  manage_template_empty_body: "Davet kodu/linki üretmek için en az bir şablon gerekir.",
  manage_template_modal_title: "Yeni QR Şablonu",
  manage_template_goal_label: "Hedef adı",
  manage_template_goal_default: "Varsayılan değer",
  manage_template_goal_add: "+ Hedef Ekle",
  manage_template_submit: "Oluştur",
  manage_template_cancel: "Vazgeç",
  manage_template_created: "Şablon oluşturuldu",
  manage_template_create_error: "QR şablonu oluşturulamadı. Lütfen tekrar deneyin.",
  manage_template_deleted: "Şablon silindi",
  manage_template_delete_error: "QR şablonu silinemedi. Lütfen tekrar deneyin.",
  manage_template_validation_label: "Hedef adı zorunlu",
  manage_template_validation_value: "Geçerli bir varsayılan değer girin",

  manage_share_modal_title: "Davet Paylaş",
  manage_share_link_label: "Davet bağlantısı",
  manage_share_copy: "Kopyala",
  manage_share_copied: "Kopyalandı",
  manage_share_qr_label: "QR Kod",
  manage_share_close: "Kapat",

  manage_danger_zone: "Tehlikeli Bölge",
  manage_delete_group_cta: "Grubu Sil",
  manage_delete_group_modal_title: "Grubu Sil",
  manage_delete_group_modal_body: "Bu işlem geri alınamaz. Onaylamak için grup adını yaz.",
  manage_delete_group_input_label: "Grup adı",
  manage_delete_group_confirm: "Sil",
  manage_delete_group_cancel: "Vazgeç",
  manage_delete_success: "Grup silindi",
  manage_delete_error: "Grup silinemedi. Lütfen tekrar deneyin.",

  // Faz 5 — Yönetim İstatistikleri + Hedef Yönetimi
  manage_stats_cta: "📊 İstatistikler",
  manage_stats_back: "◀ Grup Detayı",
  manage_stats_title: "İstatistikler",
  manage_stats_range_start: "Başlangıç",
  manage_stats_range_end: "Bitiş",
  manage_stats_preset_this_month: "Bu ay",
  manage_stats_preset_last_7: "Son 7 gün",
  manage_stats_preset_last_30: "Son 30 gün",
  manage_stats_summary_active_members: "Aktif Üye",
  manage_stats_summary_active_days: "Aktif Gün",
  manage_stats_summary_avg_completion: "Ortalama Tamamlama",
  manage_stats_table_member: "Üye",
  manage_stats_table_active_days: "Aktif Gün",
  manage_stats_table_perfect_days: "Mükemmel Gün",
  manage_stats_table_total_value: "Toplam Değer",
  manage_stats_table_completion: "Tamamlama %",
  manage_stats_chart_title: "Hedef Bazlı Tamamlama %",
  manage_stats_no_data: "Bu aralıkta hiç aktivite yok",
  manage_stats_load_error: "İstatistikler yüklenemedi. Lütfen tekrar deneyin.",
  manage_stats_invalid_range: "Bitiş başlangıçtan önce olamaz",

  manage_goals_cta: "Hedefleri",
  manage_goals_modal_title: "Hedefleri Düzenle · {name}",
  manage_goals_empty: "Henüz hedef atanmamış",
  manage_goals_add_label: "Hedef adı",
  manage_goals_add_value: "Hedef değer",
  manage_goals_add_cta: "+ Yeni Hedef",
  manage_goals_save: "Kaydet",
  manage_goals_cancel: "Vazgeç",
  manage_goals_delete: "Sil",
  manage_goals_added: "Hedef eklendi",
  manage_goals_updated: "Hedef güncellendi",
  manage_goals_deleted: "Hedef silindi",
  manage_goals_error: "Hedef işlemi tamamlanamadı. Lütfen tekrar deneyin.",
  manage_goals_close: "Kapat",

  // Faz 6 — Hatim (kullanıcı tarafı)
  hatim_title: "Hatim",
  hatim_month_label: "Ay",
  hatim_prev_month: "← Önceki",
  hatim_next_month: "Sonraki →",
  hatim_load_error: "Hatim listeniz yüklenemedi. Lütfen tekrar deneyin.",
  hatim_retry: "Tekrar dene",
  hatim_empty_title: "Bu ay için aktif hatim yok",
  hatim_empty_body: "Bir gruba katıldığında veya yöneticinin sana hatim atadığında burada görünür.",
  hatim_card_assigned_label: "Atanan",
  hatim_card_assigned_pages: "Sayfa",
  hatim_card_assigned_amount: "Hedef",
  hatim_card_completed_label: "Tamamlanan",
  hatim_card_progress_label: "İlerleme",
  hatim_card_completed_status: "Tamamlandı",
  hatim_card_in_progress_status: "Devam Ediyor",
  hatim_card_pending_status: "Beklemede",
  hatim_card_update_cta: "Güncelle",
  hatim_card_no_assignment: "Bu hatime atanmadın",
  hatim_progress_modal_title: "İlerlemeyi Güncelle",
  hatim_progress_modal_amount_label: "Tamamlanan miktar",
  hatim_progress_modal_ranges_label: "Tamamlanan sayfa aralıkları",
  hatim_progress_modal_assigned_chip: "Atanmış: {ranges}",
  hatim_range_start: "Başlangıç sayfa",
  hatim_range_end: "Bitiş sayfa",
  hatim_range_add: "+ Aralık Ekle",
  hatim_progress_save: "Kaydet",
  hatim_progress_cancel: "Vazgeç",
  hatim_progress_save_success: "İlerleme güncellendi",
  hatim_progress_save_error: "İlerlemeniz kaydedilemedi. Lütfen tekrar deneyin.",
  hatim_progress_invalid_range: "Geçersiz sayfa aralığı",

  // Faz 8 — Hatim'e Kodla Katılım
  hatim_join_code_cta: "🔑 Kodla Katıl",
  hatim_join_code_modal_title: "Kodla Hatime Katıl",
  hatim_join_code_label: "Davet kodu",
  hatim_join_code_placeholder: "8 haneli kod (örn. ABCD1234)",
  hatim_join_code_help: "Yöneticiden aldığın 8 haneli kodu yaz.",
  hatim_join_code_invalid_format: "Lütfen 8 haneli geçerli bir kod girin.",
  hatim_join_code_lookup_error: "Bu koda ait hatim bulunamadı. Kodu kontrol edip tekrar deneyin.",
  hatim_join_code_already_member: "Zaten bu hatimin üyesisiniz.",
  hatim_join_code_preview_max: "Maksimum kullanım: {n}",
  hatim_join_code_amount_label: "Almak istediğin miktar",
  hatim_join_code_submit: "Katıl",
  hatim_join_code_cancel: "Vazgeç",
  hatim_join_code_success: "Hatime katıldın",
  hatim_join_code_error: "Hatime katılma işlemi tamamlanamadı. Lütfen tekrar deneyin.",

  // Faz 7 — Hatim Yönetimi (yönetici tarafı)
  hatim_mgmt_link: "📚 Hatim Yönetimi",
  hatim_mgmt_title: "Hatim Yönetimi",
  hatim_mgmt_create_cta: "+ Yeni Hatim Şablonu",
  hatim_mgmt_create_cta_short: "Yeni Hatim",
  hatim_mgmt_count_suffix: "hatim",
  hatim_mgmt_pick_hint: "Detayları görmek için soldan bir hatim seçin.",
  hatim_mgmt_tab_settings: "Ayarlar",
  hatim_mgmt_empty_title: "Henüz yönettiğin hatim şablonu yok",
  hatim_mgmt_empty_body: "Bir şablon oluşturduğunda burada listelenecek.",
  hatim_mgmt_back: "◀ Hatim Yönetimi",
  hatim_mgmt_card_total: "Toplam",
  hatim_mgmt_card_users: "Üye",
  hatim_mgmt_card_repeat: "Tekrar",
  hatim_mgmt_load_error: "Hatim şablonu yüklenemedi. Lütfen tekrar deneyin.",
  hatim_mgmt_retry: "Tekrar dene",

  hatim_mgmt_create_modal_title: "Yeni Hatim Şablonu",
  hatim_mgmt_create_name: "Şablon adı",
  hatim_mgmt_create_type: "Tip",
  hatim_mgmt_create_type_kuran: "Kuran-ı Kerim",
  hatim_mgmt_create_type_cevsen: "Cevşen",
  hatim_mgmt_create_type_salavat: "Salavat",
  hatim_mgmt_create_type_dua: "Dua",
  hatim_mgmt_create_type_tesbih: "Tesbih",
  hatim_mgmt_create_type_other: "Diğer",
  hatim_mgmt_create_total_amount: "Toplam miktar",
  hatim_mgmt_create_total_fixed_kuran: "Kur'an-ı Kerim hatmi 600 sayfa; değiştirilemez.",
  hatim_mgmt_create_description: "Açıklama (opsiyonel)",
  hatim_mgmt_create_start_date: "Başlangıç tarihi",
  hatim_mgmt_create_end_date: "Bitiş tarihi",
  hatim_mgmt_create_duration: "Periyot",
  hatim_mgmt_create_duration_daily: "Günlük",
  hatim_mgmt_create_duration_weekly: "Haftalık",
  hatim_mgmt_create_duration_monthly: "Aylık",
  hatim_mgmt_create_duration_custom: "Özel (gün)",
  hatim_mgmt_create_duration_days: "Periyot süresi (gün)",
  hatim_mgmt_create_repeat_duration: "Kaç kez tekrarlansın? (opsiyonel)",
  hatim_mgmt_create_submit: "Oluştur",
  hatim_mgmt_create_cancel: "Vazgeç",
  hatim_mgmt_create_success: "Şablon oluşturuldu",
  hatim_mgmt_create_error: "Hatim şablonu oluşturulamadı. Lütfen tekrar deneyin.",

  hatim_mgmt_section_managers: "Yöneticiler",
  hatim_mgmt_section_users: "Atanan Üyeler",
  hatim_mgmt_section_participation: "Davet Kodları",
  hatim_mgmt_add_manager_cta: "+ Yönetici Ekle",
  hatim_mgmt_add_user_cta: "+ Üye Ekle",
  hatim_mgmt_add_participation_cta: "+ Yeni Kod",
  hatim_mgmt_add_manager_modal_title: "Yönetici Ekle",
  hatim_mgmt_add_user_modal_title: "Üye Ekle",
  hatim_mgmt_edit_user_modal_title: "Atamayı Düzenle",
  hatim_mgmt_add_user_email_label: "Email",
  hatim_mgmt_add_user_amount_label: "Atanacak miktar",
  hatim_mgmt_main_manager: "Ana Yönetici",
  hatim_mgmt_main_manager_cant_remove: "Ana yönetici kaldırılamaz",
  hatim_mgmt_managers_empty: "Henüz başka yönetici yok",
  hatim_mgmt_users_empty: "Henüz atanmış üye yok",
  hatim_mgmt_members_total: "Toplam",
  hatim_mgmt_members_assigned: "Atanan",
  hatim_mgmt_members_remaining: "Kalan",
  hatim_mgmt_members_repeat: "Tekrar",
  hatim_mgmt_members_nothing_left: "Atanacak miktar kalmadı",
  hatim_mgmt_user_edit: "Düzenle",
  hatim_mgmt_user_remove: "Hatimden çıkar",
  hatim_mgmt_assign_max_hint: "En fazla {n}",
  hatim_mgmt_assign_exceeds: "Atanacak miktar kalan miktardan fazla olamaz (en fazla {n}).",
  hatim_mgmt_ranges_taken_label: "Başka üyelere atanmış sayfalar",
  hatim_mgmt_ranges_conflict: "Seçilen sayfalar başka bir üyeye atanmış aralıkla ya da birbirleriyle çakışıyor.",

  hatim_mgmt_add_participation_modal_title: "Yeni Davet Kodu",
  hatim_mgmt_add_participation_max_count: "Kullanım hakkı (kişi sayısı)",
  hatim_mgmt_add_participation_submit: "Kod Üret",
  hatim_mgmt_add_participation_result_label: "Üretilen Kod",
  hatim_mgmt_add_participation_copy: "Kopyala",
  hatim_mgmt_add_participation_copied: "Kopyalandı",
  hatim_mgmt_add_participation_close: "Kapat",
  hatim_mgmt_participation_empty: "Henüz davet kodu yok",
  hatim_mgmt_participation_max_count_label: "Kullanım: {n}",

  hatim_mgmt_repeat_label: "Tekrar Sayısı",
  hatim_mgmt_repeat_save: "Kaydet",
  hatim_mgmt_repeat_cancel: "Vazgeç",
  hatim_mgmt_repeat_updated: "Tekrar güncellendi",
  hatim_mgmt_repeat_edit_cta: "✏ Düzenle",
  hatim_mgmt_repeat_min_hint: "En az {n} (şu anki dönem)",
  hatim_mgmt_repeat_below_min: "Tekrar sayısı şu anki dönemden ({n}) küçük olamaz.",

  hatim_mgmt_user_added: "Üye eklendi",
  hatim_mgmt_user_removed: "Üye çıkarıldı",
  hatim_mgmt_user_assignment_updated: "Atama güncellendi",
  hatim_mgmt_manager_added: "Yönetici eklendi",
  hatim_mgmt_manager_removed: "Yönetici çıkarıldı",
  hatim_mgmt_participation_added: "Kod oluşturuldu",
  hatim_mgmt_participation_removed: "Kod silindi",

  hatim_mgmt_danger_zone: "Tehlikeli Bölge",
  hatim_mgmt_delete_cta: "Şablonu Sil",
  hatim_mgmt_delete_modal_title: "Şablonu Sil",
  hatim_mgmt_delete_modal_body: "Bu işlem geri alınamaz. Onaylamak için şablon adını yaz.",
  hatim_mgmt_delete_input_label: "Şablon adı",
  hatim_mgmt_delete_confirm: "Sil",
  hatim_mgmt_delete_cancel: "Vazgeç",
  hatim_mgmt_delete_success: "Şablon silindi",

  hatim_mgmt_remove_confirm_title: "Kaldırmak istediğine emin misin?",
  hatim_mgmt_remove_confirm_body: "Bu işlemi geri alamayacaksın.",
  hatim_mgmt_remove_confirm_cta: "Kaldır",
  hatim_mgmt_remove_confirm_cancel: "Vazgeç",

  hatim_mgmt_action_error: "İşlem tamamlanamadı. Lütfen tekrar deneyin.",

  // Grup altında hatim yönetimi
  hatim_progress_title: "İlerleme",
  hatim_progress_period: "{n}. dönem",
  hatim_progress_no_active: "Aktif dönem yok, son dönem gösteriliyor.",
  hatim_progress_completed_of: "{completed}/{total} üye tamamladı",
  hatim_progress_empty: "Bu dönemde atanmış üye yok",
  hatim_progress_no_instance: "Henüz dönem oluşmamış",
  hatim_progress_load_error: "İlerleme yüklenemedi.",
  hatim_progress_assigned: "Atanan",
  hatim_progress_status_pending: "Bekliyor",
  hatim_progress_status_in_progress: "Devam ediyor",
  hatim_progress_status_completed: "Tamamlandı",
  hatim_progress_unit_pages: "sayfa",
  hatim_progress_unit_count: "adet",
  hatim_progress_remaining: "Kalan",
  hatim_progress_unassigned: "{n} Dağıtılmayan",
  hatim_progress_period_select: "Dönem Seçimi",
  hatim_progress_period_active: "Aktif",
  hatim_progress_status_title: "İlerleme Durumu",
  hatim_progress_completed_label: "Tamamlanan",
  hatim_progress_members_title: "Üyeler",
  muzakere_title: "Müzakere",
  muzakere_template_download: "Örnek Excel'i İndir",
  muzakere_upload: "Excel ile Yükle",
  muzakere_upload_hint:
    "Müzakereleri Excel'den toplu ekleyin. Yalnızca örnek dosyadaki format kabul edilir: ilk satır {headers}, tarih GG.AA.YYYY. Tek bir satır hatalıysa dosyanın tamamı reddedilir.",
  muzakere_upload_only_xlsx: "Yalnızca .xlsx uzantılı Excel dosyası yüklenebilir. Lütfen örnek dosyayı kullanın.",
  muzakere_upload_rejected: "Dosya kabul edilmedi, hiçbir müzakere eklenmedi:",
  muzakere_more_errors: "…ve {n} hata daha",
  muzakere_upload_error: "Müzakereler yüklenemedi.",
  muzakere_upload_success: "{n} müzakere eklendi.",
  muzakere_empty: "Bu grupta henüz müzakere yok.",
  muzakere_attendance: "{done}/{total} katıldı",
  muzakere_preview_title: "Müzakereler eklensin mi?",
  muzakere_preview_body: "{file} dosyasındaki {n} müzakere gruba eklenecek ve üyelere bildirim gidecek.",
  muzakere_preview_more: "…ve {n} müzakere daha",
  muzakere_preview_confirm: "Ekle",
  muzakere_cancel: "Vazgeç",
  muzakere_delete: "Sil",
  muzakere_delete_past: "Günü geçmiş müzakere silinemez",
  muzakere_delete_title: "Müzakere silinsin mi?",
  muzakere_delete_body: "\"{title}\" ve üyelerin bu müzakereye katılım kayıtları silinecek.",
  muzakere_deleted: "Müzakere silindi.",
  muzakere_delete_error: "Müzakere silinemedi.",
  // Hedef sihirbazı (mobil GoalWizard ile aynı adımlar ve metinler)
  gw_title_add: "Yeni Hedef",
  gw_title_edit: "Hedefi Düzenle",
  gw_step_work: "Hedef adı",
  gw_step_work_desc: "Yazmaya başla, kütüphanedeki eserler listelenir. Alt bölümü olan eserin içine okla girebilirsin.",
  gw_step_activity: "Nasıl",
  gw_step_activity_desc: "Bu eseri okuyor musun, ezberliyor musun, yazıyor musun?",
  gw_step_unit: "Birim",
  gw_step_unit_desc: "Bu hedefi neyle ölçüyorsun?",
  gw_step_days: "Ne kadar sürede",
  gw_step_days_desc: "Bu hedefi kaç günde tamamlamayı planlıyorsun? Yazmazsan her gün tekrarlı bir hedef olur.",
  gw_step_amount: "Hedef değeri",
  gw_step_amount_desc: "Toplamda ne kadar yapacaksın?",
  gw_step_summary: "Özet",
  gw_step_summary_desc: "Hedefin son hâli. Değiştirmek istediğin olursa geri dön.",
  gw_amount_desc_okuma: "Her gün ne kadar okuyacaksın?",
  gw_amount_desc_ezber: "Her gün ne kadar ezberleyeceksin?",
  gw_amount_desc_yazma: "Her gün ne kadar yazacaksın?",
  gw_amount_desc_dinleme: "Her gün ne kadar dinleyeceksin?",
  gw_amount_desc_calisma: "Her gün ne kadar çalışacaksın?",
  gw_search_placeholder: "Eser ara",
  gw_search_clear: "Aramayı temizle",
  gw_clear_work: "Seçimi kaldır",
  gw_open_work: "Bölümlerine gir:",
  gw_works_failed: "Eser listesi yüklenemedi.",
  gw_works_empty: "Kütüphanede eşleşen eser yok. Farklı bir arama deneyin.",
  gw_activity_okuma: "Okuma",
  gw_activity_ezber: "Ezber",
  gw_activity_yazma: "Yazma",
  gw_activity_dinleme: "Dinleme",
  gw_activity_calisma: "Çalışma",
  gw_unit_minute: "Süre (dakika)",
  gw_unit_count: "Adet",
  gw_unit_page: "Sayfa",
  gw_unit_line: "Satır",
  gw_unit_tally: "Sayaç",
  gw_unit_minute_hint: "Ne kadar süre ayırdığını dakika olarak tutar.",
  gw_unit_count_hint: "Kaç kez yaptığını sayar (bir hatim, bir bab, bir vird).",
  gw_unit_page_hint: "Kaç sayfa okuduğunu sayar, hangi sayfa olduğunu sormaz.",
  gw_unit_line_hint: "Satır sayısıyla takip edilir (ezber ve yazıda kullanışlı).",
  gw_unit_tally_hint: "Gün içinde tek tek artırdığın sayaç (zikir, salavat).",
  gw_word_minute: "dakika",
  gw_word_count: "adet",
  gw_word_page: "sayfa",
  gw_word_line: "satır",
  gw_day_mon: "Pzt",
  gw_day_tue: "Sal",
  gw_day_wed: "Çar",
  gw_day_thu: "Per",
  gw_day_fri: "Cum",
  gw_day_sat: "Cmt",
  gw_day_sun: "Paz",
  gw_every_day: "Her gün",
  gw_every_day_lower: "her gün",
  gw_days: "gün",
  gw_days_lasting: "gün devam edecek",
  gw_repeating: "Sürekli tekrarlı",
  gw_daily_goal: "Günlük hedef",
  gw_total: "Toplam",
  gw_days_field: "Gün sayısı",
  gw_days_placeholder: "örn. 60",
  gw_days_note: "Boş bırakırsan girdiğin miktar her gün yapılacak günlük hedef olur.",
  gw_days_required_note: "Eseri kaç günde bitireceğini yaz; girdiğin toplam günlere bölünür.",
  gw_amount_daily_minute: "Günde kaç dakika?",
  gw_amount_daily_line: "Günde kaç satır?",
  gw_amount_daily_page: "Günde kaç sayfa?",
  gw_amount_daily_count: "Günde kaç kez?",
  gw_amount_total_line: "kaç satır?",
  gw_amount_total_page: "kaç sayfa?",
  gw_amount_total_count: "kaç kez?",
  gw_amount_min_note: "En az {days} {unit}, her güne en az 1 düşmeli.",
  gw_sum_goal: "Hedef",
  gw_sum_activity: "Nasıl",
  gw_sum_unit: "Birim",
  gw_sum_week_days: "Hangi günler",
  gw_sum_duration: "Süre",
  gw_error_pick_work: "Listeden bir eser seçiniz.",
  gw_error_days_required: "Eser hedefinde gün sayısı zorunludur.",
  gw_error_days_min: "Gün sayısı en az 1 olmalıdır.",
  gw_error_amount: "Geçerli bir hedef değeri girin.",
  gw_error_amount_below_days: "Gün sayısından az olamaz; her güne en az 1 düşmeli.",
  gw_back: "Geri",
  gw_next: "İleri",
  gw_save: "Kaydet",
  gw_update: "Güncelle",

  // Hedeflerim
  my_goals_subtitle: "Günlük hedeflerin, takip ayarlarıyla.",
  my_goals_custom_count: "{count} özel",
  my_goals_empty_title: "Henüz hedef eklenmemiş",
  my_goals_empty_body: "İlk hedefini ekleyerek başla ve ilerlemeni takip et.",
  my_goals_badge_custom: "Özel",
  my_goals_badge_general: "Genel",
  my_goals_info: "Genel hedefler grup yöneticinden gelir; değiştirilemez veya silinemez. Özel hedefler senin eklediklerindir; değiştirmek için silip yeniden ekleyebilirsin.",
  my_goals_add: "Hedef Ekle",
  my_goals_locked: "Genel hedef, değiştirilemez",
  my_goals_delete_title: "Hedefi Sil",
  my_goals_delete_body: "\"{label}\" hedefini silmek istediğine emin misin?",

  // QR şablonu hedefleri
  manage_template_edit_title: "QR Şablonunu Düzenle",
  manage_template_edit_cta: "Düzenle",
  manage_template_updated: "Şablon güncellendi",
  manage_template_name: "QR adı",
  manage_template_name_hint: "Boş bırakırsan grubun adı",
  manage_template_no_goals: "Henüz hedef yok. Katılan kişiye eklenecek hedefleri ekle.",
  manage_template_duplicate: "Aynı isim ve biçimde iki hedef olamaz.",
  manage_template_too_many: "QR şablonunda en fazla 20 hedef olabilir.",
  manage_template_wizard_subtitle: "QR ile katılana eklenecek hedef",
  manage_template_add_to_list: "Listeye ekle",

  // Ünvanlarım
  nav_titles: "Ünvanlarım",
  titles_my_title: "Ünvanım",
  titles_none: "Henüz ünvan yok",
  titles_earned_count: "{count} ünvan kazandın",
  titles_load_error: "Ünvanlar yüklenemedi",
  titles_dialog_title: "Ünvan",
  titles_earned: "Kazanıldı",
  titles_locked: "Kilitli",
  titles_remaining: "Kalan",
  titles_family_earned: "kazanıldı",
  titles_next: "Sıradaki",
  titles_left: "kaldı",
  titles_family_complete: "Bu ailenin bütün ünvanları kazanıldı",
  titles_earned_of_total: "{count} / {total} ünvan kazanıldı",
  titles_overall: "Genel ilerleme",
  titles_closest: "Kazanmaya en yakın",
  titles_tier_bronz: "Bronz",
  titles_tier_gumus: "Gümüş",
  titles_tier_altin: "Altın",
  titles_earned_on: "{date}'da kazanıldı",
  titles_avatar_set: "Profil resmi yap",
  titles_avatar_clear: "Profil resminden kaldır",
  titles_avatar_saved: "Profil resmin güncellendi",
  titles_avatar_cleared: "Profil resmin kaldırıldı",
  titles_avatar_error: "Profil resmi kaydedilemedi",
  cs_offline_title: "İnternete ulaşılamıyor",
  cs_offline_body: "Bağlantınızı kontrol edip tekrar deneyin. Kayıtlarınız kaybolmaz.",
  cs_maintenance_title: "Kısa bir bakımdayız",
  cs_maintenance_body: "Birkaç dakika içinde geri döneceğiz. Anlayışınız için teşekkürler.",
  cs_error_title: "Bir şeyler ters gitti",
  cs_error_body: "Bu bölüm şu an yüklenemedi. Biraz sonra tekrar deneyin.",
  cs_retry: "Tekrar dene",
  titles_unit_hours: "saat",
  titles_weeks_in_a_row: "hafta üst üste",
  cs_retrying: "Deneniyor",
  member_code_one_time: "Kod tek kullanımlık: kişi bir gruba eklenince kodu yenilenir.",
  titles_meaning_label: "Anlamı",

  // Kaza namazları
  nav_kaza: "Kaza Namazlarım",
  kaza_total_remaining: "Toplam Kalan Kaza",
  kaza_mezhep: "Mezhep",
  kaza_mezhep_hanefi: "Hanefi",
  kaza_mezhep_safii: "Şafii",
  kaza_mezhep_maliki: "Maliki",
  kaza_mezhep_hanbeli: "Hanbeli",
  kaza_vitir_hint: "Vitir namazı yalnızca Hanefi mezhebinde kaza edilir.",
  kaza_by_prayer: "Vakitlere Göre Kalan Kaza",
  kaza_prayer_sabah: "Sabah",
  kaza_prayer_ogle: "Öğle",
  kaza_prayer_ikindi: "İkindi",
  kaza_prayer_aksam: "Akşam",
  kaza_prayer_yatsi: "Yatsı",
  kaza_prayer_vitir: "Vitir",
  kaza_add_by_years: "Yıl / Gün ile Ekle",
  kaza_add_by_years_hint: "Kaç yıl ve gün namaz kılınmadıysa girin; her vakte o kadar gün eklenir.",
  kaza_years: "Yıl",
  kaza_days: "Gün",
  kaza_add: "Ekle",
  kaza_saved: "Kaza bilgileri kaydedildi.",
  kaza_save_failed: "Kaza bilgileri kaydedilemedi.",
  kaza_load_failed: "Kaza bilgileri yüklenemedi.",
  kaza_day_title: "Kaza Namazı",
  kaza_remaining: "Kalan",
  kaza_prayed: "Kılınan",
  kaza_increase: "bir artır",
  kaza_decrease: "bir azalt",
  kaza_day_saved: "Kaza namazları kaydedildi.",
  kaza_day_save_failed: "Kaza namazları kaydedilemedi.",
  kaza_view_only: "Bu gün için yalnızca görüntüleme yapılabilir.",

  // Terakkim yuvarlakları
  circles_title: "Hatim, müzakere ve kaza",
  circles_hatim: "Hatim",
  circles_no_hatim: "Hatim yok",
  circles_group: "Grup",
  circles_join: "Katıl",
  circles_focus: "Odak",
  circles_kaza_setup: "Borç ekle",
  kaza_debt_tab: "Kaza borcum",
  kaza_not_set_up: "Henüz kaza borcu girilmedi. Önce kaza borcunuzu girin.",
  circles_join_hatim: "Hatime Katıl",
  my_goals_edit: "Hedeflerimi yönet",
  mygroups_title: "Gruplarımdaki durumum",
  mygroups_week: "Bu hafta",
  mygroups_rank: "Sıra",
  mygroups_completion: "Tamamlama",
  mygroups_streak: "Seri",
  mygroups_perfect: "Tam gün",
  mygroups_members: "üye",
  mygroups_count_unit: "grup",
  mygroups_streak_unit: "seri",
  mygroups_perfect_unit: "tam gün",
  mygroups_empty: "Henüz bir gruba üye değilsiniz.",
  circles_kaza: "Kaza",
  circles_left: "kaldı",
  circles_muzakere: "Müzakere",
  circles_no_muzakere: "Müzakere yok",

  // Müzakere (üye)
  muz_no_description: "Açıklama eklenmemiş.",
  muz_participants: "Katılanlar",
  muz_absentees: "Katılmayanlar",
  muz_no_participants: "Henüz katılan yok.",
  muz_attended: "Katıldın",
  muz_mark_done: "Katıldım",
  muz_undo: "Geri Al",
  muz_done_saved: "Katılımınız kaydedildi.",
  muz_done_undone: "Katılım geri alındı.",
  muz_save_failed: "Müzakere kaydedilemedi",
  muz_not_yet: "Bu müzakerenin günü henüz gelmedi.",
  muz_expired: "Bu müzakerenin işaretleme süresi doldu.",
  muz_answer_questions: "Soruları cevapla",
  muz_see_result: "Sonucu gör",

  // Müzakere değerlendirmesi
  assess_title: "Soruları Cevapla",
  assess_not_open: "Değerlendirme henüz açılmadı.",
  assess_closed: "Değerlendirme kapandı.",
  assess_none: "Bu müzakerede soru yok.",
  assess_load_failed: "Değerlendirme yüklenemedi.",
  assess_question_word: "soru",
  assess_question: "Soru",
  assess_open_today: "Bugün gün sonuna kadar açık.",
  assess_write_answer: "Cevabınızı yazın",
  assess_yes: "Evet",
  assess_no: "Hayır",
  assess_true: "Doğru",
  assess_false: "Yanlış",
  assess_review: "Gözden geçir",
  assess_review_hint: "Cevaplarını gözden geçir, sonra gönder.",
  assess_unanswered: "Cevaplanmadı",
  assess_give_up: "Vazgeç",
  assess_submit: "Gönder",
  assess_submitted: "Cevaplarınız gönderildi.",
  assess_submit_failed: "Cevaplar gönderilemedi",
  assess_your_result: "Sonucunuz",
  assess_your_answer: "Cevabınız",
  assess_correct_answer: "Doğru cevap",
  assess_no_scored: "Puanlanan soru yok",
  assess_correct_word: "doğru",

  // Odaklan
  focus_title: "Odaklan",
  focus_tab_focus: "Odaklan",
  focus_tab_history: "Geçmiş",
  focus_tab_stats: "İstatistik",
  focus_how_long: "Ne kadar odaklanacaksın",
  focus_running: "Devam ediyor",
  focus_time_up: "Süre doldu",
  focus_work: "Çalışma",
  focus_break: "Mola",
  focus_round: "tur",
  focus_free: "Serbest",
  focus_free_session: "Serbest odaklanma",
  focus_min: "dk",
  focus_pomodoro: "Pomodoro",
  focus_pomodoro_hint: "{work} dk çalışma, {short} dk mola; {rounds}. turda {long} dk",
  focus_free_hint: "Serbest kip ileri sayar, en fazla 3 saat. Sekme arka planda kalsa da süre doğru sayılır.",
  focus_which_goal: "Hangi hedef için",
  focus_start: "Başlat",
  focus_cancel: "Vazgeç",
  focus_finish: "Bitir ve kaydet",
  focus_to_break: "Molaya geç",
  focus_next_round: "Tura devam",
  focus_too_short: "Bir dakikadan kısa, kaydedilmedi",
  focus_saved_minutes: "{minutes} dakika kaydedildi",
  focus_save_failed: "Süre kaydedilemedi",
  focus_no_sessions: "Henüz odak seansın yok.",
  focus_today: "Bugün",
  focus_today_lower: "bugün",
  focus_sessions: "seans",
  focus_last_30: "Son 30 gün",
  focus_group_ranking: "Grupta odak sıralaması",
  focus_no_ranking: "Bu ay kimse odak sayacı kullanmamış.",
  focus_no_groups: "Sıralama için bir gruba üye olmalısın.",

  // Müzakere ekleme ve değerlendirme (web)
  mzq_type: "Soru tipi",
  mzq_type_coktan: "Çoktan seçmeli",
  mzq_type_evethayir: "Evet / Hayır",
  mzq_type_dogruyanlis: "Doğru / Yanlış",
  mzq_type_acik: "Açık uçlu",
  mzq_issue_text: "Soru metnini yazınız.",
  mzq_issue_text_length: "Soru metni en fazla 300 karakter olabilir.",
  mzq_issue_options_count: "Şık sayısı 2 ile 6 arasında olmalıdır.",
  mzq_issue_option_empty: "Boş şık bırakmayınız.",
  mzq_issue_option_length: "Şık en fazla 120 karakter olabilir.",
  mzq_issue_correct: "Doğru cevabı seçiniz.",
  mzq_issue_too_many: "En fazla 30 soru eklenebilir.",
  mzq_new_question: "Yeni soru",
  mzq_edit_question: "Soruyu düzenle",
  mzq_remove_question: "Soruyu kaldır",
  mzq_text: "Soru metni",
  mzq_options: "Şıklar",
  mzq_options_hint: "Şıkları yazın, doğru olanı işaretleyin.",
  mzq_option: "Şık",
  mzq_mark_correct: "Doğru şık",
  mzq_remove_option: "Şıkkı kaldır",
  mzq_add_option: "Şık ekle",
  mzq_open_hint: "Açık uçlu soruda doğru cevap yoktur, cevapları yönetici okur.",
  mzq_selected_package: "Seçili paket",
  mzq_remove_package: "Paketi kaldır",
  mzq_pick_from_library: "Kütüphaneden seç",
  mzq_pick_package: "Paket seç",
  mzq_tab_mine: "Paketlerim",
  mzq_tab_starred: "Yıldızlılarım",
  mzq_tab_explore: "Keşfet",
  mzq_search_package: "Paket ara",
  mzq_no_packages: "Paket bulunamadı.",
  mzq_packages_failed: "Paketler yüklenemedi.",
  mzq_package_failed: "Paket yüklenemedi.",
  mzq_lock_reason: "Bu paketi görmek için izin gerekli",
  mzq_lock_reason_a: "Paketin sahibi grubunuzun yöneticisi",
  mzq_lock_reason_b: "Paket grubunuzdaki bir değerlendirmede kullanılıyor",
  mzq_request_access: "İzin iste",
  mzq_access_pending: "İzin bekleniyor",
  mzq_request_failed: "İzin istenemedi",
  mzq_save_as_package: "Paket olarak kaydet",
  mzq_save_as_package_hint: "Sorular kütüphanende özel bir paket olarak saklanır, sonra başka müzakerelerde de kullanabilirsin.",
  mzq_package_title: "Paket adı",
  mzq_package_saved: "Paket olarak kaydedildi.",
  mzq_package_save_failed: "Paket kaydedilemedi",
  mzq_no_questions_hint: "Soruları kütüphaneden seçebilir ya da kendin ekleyebilirsin. Sorusuz da devam edebilirsin.",
  mzw_add_title: "Müzakere Ekle",
  mzw_edit_questions_title: "Soruları düzenle",
  mzw_questions: "Paket ve sorular",
  mzw_questions_desc: "İstersen kütüphaneden paket seç ya da soru ekle, sorusuz da devam edebilirsin.",
  mzw_questions_only: "Sorular",
  mzw_questions_only_desc: "Değerlendirme başlatılana kadar sorular değiştirilebilir. Hepsini kaldırırsan müzakere sorusuz olur.",
  mzw_info: "Müzakere",
  mzw_info_desc: "Başlığı yaz, istersen kısa bir açıklama ekle.",
  mzw_repeat: "Tekrar",
  mzw_repeat_desc: "Bir kez mi yapılacak, her hafta mı, her ay mı?",
  mzw_once: "Tek sefer",
  mzw_weekly: "Haftalık",
  mzw_monthly: "Aylık",
  mzw_date: "Tarih",
  mzw_date_desc: "Müzakerenin gününü seç.",
  mzw_date_single_desc: "Sorulu müzakere tek sefer yapılır. Müzakerenin gününü seç.",
  mzw_date_too_early: "Geçmiş haftalara müzakere eklenemez.",
  mzw_weekday: "Gün",
  mzw_weekday_desc: "Hangi gün yapılacak ve kaç kez tekrarlanacak?",
  mzw_monthday: "Ayın günü",
  mzw_monthday_desc: "Ayın hangi günü yapılacak ve kaç kez tekrarlanacak?",
  mzw_month_clamp_hint: "Ay bu günü içermiyorsa ayın son günü kullanılır.",
  mzw_count: "Kaç kez",
  mzw_count_less: "Azalt",
  mzw_count_more: "Artır",
  mzw_every_week: "Her hafta",
  mzw_every_month: "Her ay",
  mzw_times: "kez",
  mzw_summary: "Özet",
  mzw_summary_desc: "Bilgileri kontrol et, sonra kaydet.",
  mzw_title_label: "Başlık",
  mzw_description_label: "Açıklama (isteğe bağlı)",
  mzw_description_short: "Açıklama",
  mzw_questions_short: "Sorular",
  mzw_no_questions: "Sorusuz",
  mzw_notify_hint: "Müzakere eklenince grup üyelerine bildirim gider.",
  mzw_notify_series_hint: "{n} müzakere eklenecek, grup üyelerine tek bildirim gider.",
  mzw_saved: "Müzakere eklendi.",
  mzw_saved_series: "{n} müzakere eklendi.",
  mzw_save_failed: "Müzakere kaydedilemedi",
  mzw_questions_saved: "Sorular kaydedildi.",
  mzw_questions_save_failed: "Sorular kaydedilemedi",
  mzw_questions_load_failed: "Sorular yüklenemedi",
  mzw_uncertain: "İşlem sunucuda sürüyor olabilir. Grubu yenileyip kontrol ediniz.",
  mzw_back_to_group: "Gruba dön",
  mza_state_ready: "Değerlendirme hazır",
  mza_state_open: "Değerlendirme açık",
  mza_state_closed: "Değerlendirme kapandı",
  mza_add_questions: "Soru ekle",
  mza_edit_questions: "Soruları düzenle",
  mza_results: "Sonuçlar",
  mza_start: "Başlat",
  mza_start_title: "Değerlendirmeyi başlat",
  mza_start_body: "Değerlendirme gün sonuna kadar açık kalır ve üyelere bildirim gider. Başlatılsın mı?",
  mza_started: "Değerlendirme başlatıldı.",
  mza_start_failed: "İşlem yapılamadı",
  mza_start_not_yet: "Değerlendirme müzakere günü başlatılabilir.",
  mza_start_expired: "Değerlendirme başlatma süresi doldu.",
  mza_members_answer: "Bu müzakerede üyeler soruları kendileri cevaplar, yönetici adına işaretlenemez.",
  mza_attendance_by_answers: "Cevaplarını gönderen üye katılmış sayılır.",
  mzr_title: "Değerlendirme Sonuçları",
  mzr_submitted: "Gönderenler",
  mzr_not_submitted: "Göndermeyenler",
  mzr_average: "Ortalama başarı",
  mzr_questions: "Sorular",
  mzr_state_open: "Değerlendirme gün sonuna kadar açık",
  mzr_state_closed: "Değerlendirme kapandı",
  mzr_answered_count: "{n}/{total} cevapladı",
  mzr_correct_rate: "%{pct} doğru",
  mzr_show_answers: "Cevapları göster",
  mzr_hide_answers: "Cevapları gizle",
  mzr_none_submitted: "Henüz gönderen yok.",
  mzr_everyone_submitted: "Herkes gönderdi.",
  mzr_answer_unknown: "Cevap bilgisi yok",
  mzr_old_server_hint: "Seçenek dağılımı için sunucunun güncellenmesi gerekiyor, şimdilik yalnız açık uçlu cevaplar görünür.",
  mzr_load_failed: "Sonuçlar yüklenemedi.",
  mzr_refresh: "Yenile",

  // Grup yönetimi: toplu hedef, kişi ekleme, üye ünvanları (web)
  bulk_title: "Toplu Hedef Ata",
  bulk_subtitle: "Seçili üyelere aynı hedefleri ver",
  bulk_step_goals: "Hedefler",
  bulk_step_goals_desc: "Verilecek hedefleri seç. Şablona tıklarsan hedefler listeye dolar.",
  bulk_step_members: "Üyeler",
  bulk_step_members_desc: "Hedeflerin verileceği üyeleri seç.",
  bulk_step_preview: "Önizleme",
  bulk_step_preview_desc: "Atamadan önce kimde ne değişeceğine bak.",
  bulk_step_result: "Sonuç",
  bulk_step_result_desc: "Atama tamamlandı.",
  bulk_my_templates: "Şablonlarım",
  bulk_goals_section: "Hedefler",
  bulk_goals_empty: "Şablon seçin ya da hedef ekleyin.",
  bulk_templates_empty: "Henüz şablonunuz yok. Listeyi şablon olarak kaydedebilirsiniz.",
  bulk_templates_error: "Şablonlar yüklenemedi",
  bulk_template_used: "{n} kez kullanıldı",
  bulk_template_never_used: "Hiç kullanılmadı",
  bulk_goal_count: "{n} hedef",
  bulk_save_template: "Şablon olarak kaydet",
  bulk_update_template: "Şablonu güncelle",
  bulk_save_as_new_template: "Yeni şablon olarak kaydet",
  bulk_rename_template: "Yeniden adlandır",
  bulk_template_name: "Şablon adı",
  bulk_template_saved: "Şablon kaydedildi.",
  bulk_template_updated: "Şablon güncellendi.",
  bulk_template_deleted: "Şablon silindi.",
  bulk_template_save_error: "Şablon kaydedilemedi",
  bulk_template_delete_error: "Şablon silinemedi",
  bulk_delete_template_title: "Şablonu Sil",
  bulk_delete_template_body: "\"{name}\" şablonunu silmek istediğinizden emin misiniz? Listedeki hedefler yerinde kalır.",
  bulk_duplicate_goal: "Bu ad ve biçimde bir hedef listede zaten var.",
  bulk_remove_goal: "Listeden çıkar",
  bulk_too_many_goals: "Tek seferde en fazla {n} hedef verilebilir.",
  bulk_wizard_subtitle: "Listeye eklenecek hedef",
  bulk_search_member: "Üye ara",
  bulk_selected_count: "{n} / {total} seçili",
  bulk_select_all: "Tümünü seç",
  bulk_unselect_all: "Tümünü kaldır",
  bulk_too_many_members: "En fazla {n} üye seçebilirsiniz.",
  bulk_no_members: "Grupta üye yok.",
  bulk_no_match: "Aramaya uyan üye yok.",
  bulk_will_add: "{n} kişiye eklenecek",
  bulk_will_update: "{n} kişide güncellenecek",
  bulk_added: "{n} eklendi",
  bulk_updated: "{n} güncellendi",
  bulk_failed_count: "{n} kişiye eklenemedi",
  bulk_no_change: "Değişiklik yok",
  bulk_in_people: "{n} kişide",
  bulk_unit_changes: "Birimi değişecekler",
  bulk_per_member: "Kimde ne değişecek",
  bulk_per_member_done: "Kimde ne değişti",
  bulk_cannot_add: "Eklenemeyecekler",
  bulk_could_not_add: "Eklenemeyenler",
  bulk_action_add: "eklenecek",
  bulk_action_added: "eklendi",
  bulk_action_update: "güncellenecek",
  bulk_action_updated: "güncellendi",
  bulk_reason_not_in_group: "Grupta değil",
  bulk_reason_deleted: "Kullanıcı silinmiş",
  bulk_reason_not_found: "Kullanıcı bulunamadı",
  bulk_reason_save_failed: "Hedefler kaydedilemedi",
  bulk_preview_error: "Önizleme hazırlanamadı",
  bulk_assign_error: "Hedefler atanamadı",
  bulk_nobody_assignable: "Hedef atanabilecek üye yok.",
  bulk_uncertain: "İşlem sunucuda sürüyor olabilir. Grubu yenileyip kontrol ediniz.",
  bulk_assign: "Ata",
  bulk_done: "Tamam",
  bulk_back_to_group: "Gruba dön",
  ap_step_identify: "Kişiyi Bul",
  ap_step_identify_desc: "Kişinin e-posta adresini ve yan menüde görünen 8 haneli kodunu yazın.",
  ap_step_person: "Kişi",
  ap_step_person_desc: "Bilgileri kontrol edin.",
  ap_step_goals: "Hedef ver",
  ap_step_goals_desc: "İsterseniz şimdi hedef verin; sonra da verebilirsiniz.",
  ap_step_permissions: "Yetkiler",
  ap_step_permissions_desc: "Yöneticinin bu grupta neler yapabileceğini seçin.",
  ap_step_confirm: "Onay",
  ap_step_confirm_member_desc: "Kişi gruba eklenecek.",
  ap_step_confirm_manager_desc: "Kişi bu grubun yöneticisi olacak.",
  ap_email_label: "E-posta adresi",
  ap_searching: "Aranıyor...",
  ap_lookup_error: "Kişi bilgileri alınamadı",
  ap_already_member: "Zaten üye",
  ap_already_manager: "Zaten yönetici",
  ap_goals: "Hedefler",
  ap_no_goals: "Hedefi yok",
  ap_no_goals_given: "Hedef verilmeyecek",
  ap_groups: "Bulunduğu gruplar",
  ap_no_groups: "Grubu yok",
  ap_stats: "İstatistik",
  ap_longest_streak: "En uzun seri",
  ap_current_streak: "Güncel seri",
  ap_last_30: "Son 30 gün",
  ap_perm_add: "Üye ekleyebilir",
  ap_perm_remove: "Üye çıkarabilir",
  ap_perm_capped: "Sizde olmayan yetki verilemez",
  ap_not_now: "Şimdi değil",
  ap_add_to_group: "Gruba Ekle",
  ap_make_manager: "Yönetici Yap",
  ap_result_member: "{name} gruba eklendi",
  ap_result_manager: "{name} yönetici yapıldı",
  ap_result_goals: "{n} hedef verildi",
  ap_result_goals_failed: "hedefler verilemedi",
  mt_earned_count: "{count} ünvan kazandı",
  mt_completion: "Tamamlama",
  mt_load_error: "Bilgi alınamadı",
  // Müzakere kütüphanesi (web)
  nav_library: "Müzakere Kütüphanem",
  lib_import_cta: "Excel'den yükle",
  lib_import_row_hint: "Sorulu paketleri toplu yükle, örnek dosyayı indir",
  lib_import_title: "Excel'den paket yükle",
  lib_import_subtitle: "Bir dosyada birden çok sorulu paket",
  lib_import_step_template: "1. Örnek dosyayı indir",
  lib_import_template_hint: "Her satır bir soru; aynı paket adını taşıyan satırlar tek pakette toplanır. İkinci sayfada nasıl doldurulacağı yazıyor.",
  lib_import_download_template: "Örnek Excel'i indir",
  lib_import_step_file: "2. Doldurduğun dosyayı seç",
  lib_import_pick_file: "Dosya seç",
  lib_import_errors_title: "{count} hata bulundu",
  lib_import_errors_hint: "Dosyayı düzeltip yeniden seç; hatalı dosyadan hiçbir paket yüklenmez.",
  lib_import_preview_title: "{count} paket yüklenmeye hazır",
  lib_import_submit_review: "Yüklerken onaya gönder",
  lib_import_upload: "{count} paketi yükle",
  lib_import_upload_empty: "Yükle",
  lib_import_retry: "Kalan {count} paketi yeniden dene",
  lib_import_created: "Oluşturuldu",
  lib_import_sent_review: "Onaya gönderildi",
  lib_import_failed_one: "Yüklenemedi",
  lib_import_done: "{count} paket yüklendi",
  lib_import_partial: "{ok}/{total} paket yüklendi; kalanları yeniden deneyebilirsin",
  lib_import_summary: "{ok}/{total} paket yüklendi.",
  lib_title: "Müzakere Kütüphanesi",
  lib_subtitle: "Soru paketleri; paylaş, çatalla, öner",
  lib_tab_mine: "Paketlerim",
  lib_tab_explore: "Keşfet",
  lib_tab_starred: "Yıldızlılarım",
  lib_sort: "Sıralama",
  lib_sort_stars: "Yıldıza göre",
  lib_sort_new: "En yeni",
  lib_sort_forks: "Çatala göre",
  lib_only_recommended: "Yalnız Terakki tavsiyeleri",
  lib_empty_mine: "Henüz paketiniz yok.",
  lib_empty_starred: "Henüz yıldızladığınız paket yok.",
  lib_empty_explore: "Paket bulunamadı.",
  lib_more: "Daha fazla",
  lib_retry: "Tekrar dene",
  lib_back: "Geri",
  lib_close: "Kapat",
  lib_new_package: "Yeni paket",
  lib_new_package_title: "Yeni Paket",
  lib_edit_package: "Paketi Düzenle",
  lib_package: "Paket",
  lib_word_package: "paket",
  lib_word_question: "soru",
  lib_word_star: "yıldız",
  lib_word_fork: "çatal",
  lib_word_open_proposal: "açık öneri",
  lib_usage_groups: "grupta uygulandı",
  lib_usage_people: "kişi cevapladı",
  lib_usage_none: "Henüz hiçbir grupta uygulanmadı",
  lib_badge_recommended: "Terakki Tavsiyesi",
  lib_badge_verified: "Terakki Onaylı",
  lib_badge_private: "Özel",
  lib_badge_pending: "Onay bekliyor",
  lib_badge_forked: "Çatallandı",
  lib_version: "Sürüm",
  lib_forked_from: "Çatallandığı paket",
  lib_private_hint: "Bu paket özel: yalnız siz görürsünüz ve kendi müzakerelerinizde kullanırsınız. İsterseniz onaya gönderin, onaylanınca kütüphanede herkese açılır.",
  lib_pending_hint: "Paket Terakki onayından sonra kütüphanede herkese açılır. O zamana kadar yalnız siz görürsünüz, kendi müzakerelerinizde kullanabilirsiniz.",
  lib_locked_hint: "Bu paketin soruları grubunuzdaki değerlendirme bitene kadar izinle görülebilir.",
  lib_star: "Yıldızla",
  lib_starred: "Yıldızlı",
  lib_fork: "Çatalla",
  lib_forked: "Paket çatallandı.",
  lib_edit: "Düzenle",
  lib_delete: "Sil",
  lib_delete_title: "Paketi Sil",
  lib_delete_text: "Paket silinecek. Emin misiniz?",
  lib_deleted: "Paket silindi.",
  lib_report: "Bildir",
  lib_report_title: "Paketi Bildir",
  lib_report_text: "Bu paketi uygunsuz olarak bildirmek istiyor musunuz?",
  lib_reported: "Paket bildirildi.",
  lib_submit: "Onaya gönder",
  lib_submitted: "Paket onaya gönderildi.",
  lib_made_private: "Paket artık özel.",
  lib_withdraw_review: "Onaydan geri çek",
  lib_withdraw_review_text: "Paket onay sırasından çıkar ve özel olur. İstediğiniz zaman yeniden gönderebilirsiniz.",
  lib_unpublish: "Yayından kaldır",
  lib_unpublish_confirm: "Kaldır",
  lib_unpublish_text: "Paket kütüphaneden kalkar, yalnız siz görürsünüz. Yeniden yayımlamak için onaya göndermeniz gerekir.",
  lib_submit_hint: "Onaylanınca kütüphanede herkese açılır. Göndermezseniz paket özel kalır, yalnız siz kullanırsınız.",
  lib_reverify_hint: "Onaylı paketin içeriği değişirse yeniden onay bekler.",
  lib_propose: "Değişiklikleri öner",
  lib_propose_hint: "Değişiklikleriniz asıl paketin sahibine gönderilecek.",
  lib_propose_on_save: "Kaydedince asıl pakete öner",
  lib_send_proposal: "Öneriyi Gönder",
  lib_proposal_sent: "Öneri gönderildi.",
  lib_message_optional: "Mesaj (isteğe bağlı)",
  lib_proposals: "Öneriler",
  lib_my_proposals: "Önerilerim",
  lib_no_proposals: "Öneri yok.",
  lib_stargazers: "Yıldızlayanlar",
  lib_no_stargazers: "Henüz yıldızlayan yok.",
  lib_forks: "Çatallar",
  lib_no_forks: "Çatal yok.",
  lib_questions: "Sorular",
  lib_no_questions: "Pakette soru yok.",
  lib_action_failed: "İşlem yapılamadı",
  lib_access_denied: "İzin verilmedi",
  lib_access_requested: "İzin istendi.",
  lib_not_owner: "Bu paketi yalnız sahibi düzenleyebilir.",
  lib_step_info: "Bilgi",
  lib_step_info_desc: "Paketin başlığını, açıklamasını ve etiketlerini yazın.",
  lib_step_questions: "Sorular",
  lib_step_questions_desc: "Soruları ekleyin, her sorunun doğru cevabını seçin.",
  lib_step_summary: "Özet",
  lib_step_summary_desc: "Kaydetmeden önce paketi gözden geçirin.",
  lib_field_title: "Başlık",
  lib_field_description: "Açıklama (isteğe bağlı)",
  lib_field_description_short: "Açıklama",
  lib_field_tags: "Etiketler (virgülle ayırın)",
  lib_field_tags_short: "Etiketler",
  lib_issue_title: "Paket başlığı 1 ile 80 karakter olmalıdır.",
  lib_issue_description: "Açıklama en fazla 1000 karakter olabilir.",
  lib_issue_tags_count: "En fazla 8 etiket eklenebilir.",
  lib_issue_tag_length: "Etiket en fazla 30 karakter olabilir.",
  lib_prev: "Geri",
  lib_next: "İleri",
  lib_saved: "Paket kaydedildi.",
  lib_uncertain: "İşlem sunucuda sürüyor olabilir. Kütüphaneyi yenileyip kontrol ediniz.",
  lib_back_to_library: "Kütüphaneye dön",
  lib_search_questions: "Diğer paketlerden soru ara",
  lib_search_question_placeholder: "Soru ara",
  lib_search_min: "Aramak için en az 2 harf yazınız.",
  lib_search_empty: "Sonuç bulunamadı.",
  lib_search_added: "Eklendi",
  lib_search_skipped: "Eklenmedi: aynı soru listede var ya da liste dolu.",
  lib_open_library: "Kütüphaneyi yeni sekmede aç",
  lib_proposal: "Öneri",
  lib_proposal_failed: "Öneri yüklenemedi.",
  lib_prop_open: "Açık",
  lib_prop_accepted: "Kabul edildi",
  lib_prop_rejected: "Reddedildi",
  lib_prop_withdrawn: "Geri çekildi",
  lib_open_original: "Asıl paketi aç",
  lib_open_fork: "Çatalı aç",
  lib_reply: "Cevap",
  lib_reply_optional: "Cevap (isteğe bağlı)",
  lib_diff_none: "Fark yok",
  lib_diff_added_word: "eklenen",
  lib_diff_removed_word: "çıkarılan",
  lib_diff_changed_word: "değişen",
  lib_diff_meta_word: "bilgi değişikliği",
  lib_diff_meta: "Bilgi değişiklikleri",
  lib_diff_added: "Eklenen sorular",
  lib_diff_removed: "Çıkarılan sorular",
  lib_diff_changed: "Değişen sorular",
  lib_diff_changed_parts: "Değişen",
  lib_diff_current: "Mevcut",
  lib_diff_proposed: "Önerilen",
  lib_part_type: "tip",
  lib_part_text: "metin",
  lib_part_options: "şıklar",
  lib_part_correct: "doğru cevap",
  lib_conflict: "Çakışma",
  lib_conflict_hint: "Asıl paketteki soru öneriden sonra değişmiş. Hangisi kalsın?",
  lib_accept: "Kabul Et",
  lib_accept_hint: "Öneri pakete uygulanacak ve önerene bildirilecek.",
  lib_reject: "Reddet",
  lib_reject_hint: "Öneri reddedilecek ve önerene bildirilecek.",
  lib_proposal_accepted: "Öneri kabul edildi.",
  lib_proposal_rejected: "Öneri reddedildi.",
  lib_withdraw: "Geri Çek",
  lib_withdraw_text: "Öneri geri çekilsin mi?",
  lib_proposal_withdrawn: "Öneri geri çekildi.",
  lib_requests_title: "İzin istekleri",
  lib_requests_row_hint: "Kilitli paketler için gelen ve giden istekler",
  lib_requests_failed: "İstekler yüklenemedi.",
  lib_no_requests: "İstek yok.",
  lib_req_incoming: "Gelen",
  lib_req_outgoing: "Giden",
  lib_req_pending: "Bekliyor",
  lib_req_approved: "Onaylandı",
  lib_req_rejected: "Reddedildi",
  lib_req_stale: "Güncelliğini yitirdi, yeniden isteyebilirsiniz",
  lib_pending_requests: "bekleyen istek",
  lib_wants_to_see: "paketini görmek istiyor",
  lib_group_member_suffix: "grubunuzun üyesi",
  lib_has_copy: "Bu kişide paketin bir kopyası var",
  lib_approve: "Onayla",
  lib_approve_hint: "İsteyen, paketin sorularını izin süresince görebilecek.",
  lib_reject_request_hint: "İstek reddedilecek ve isteyene bildirilecek.",
  lib_access_granted: "İzin verildi.",
  lib_request_rejected: "İstek reddedildi.",
  // Grup ayarları
  gs_notifications_title: "Bildirimler",
  gs_notifications_hint: "Değişiklikler hemen kaydedilir.",
  gs_notif_muzakere_title: "Müzakere eklendiğinde",
  gs_notif_muzakere_desc: "Yeni müzakere eklenince üyelere bildirim gider.",
  gs_notif_assessment_title: "Değerlendirme başladığında",
  gs_notif_assessment_desc: "Müzakere değerlendirmesi açılınca üyelere bildirim gider.",
  gs_notif_goal_title: "Hedef değişikliklerinde",
  gs_notif_goal_desc: "Bir üyenin hedefi eklenince, değişince ya da silinince ona bildirim gider.",
  gs_notif_joined_title: "Gruba eklenince",
  gs_notif_joined_desc: "Gruba ya da yöneticiliğe eklenen kişiye bildirim gider.",
  gs_notif_manager_title: "Yönetim hareketlerinde",
  gs_notif_manager_desc: "Üye ve yönetici ekleme-çıkarma gibi işlerde diğer yöneticilere bildirim gider.",
  gs_visibility_title: "Görünürlük",
  gs_members_see_goals_title: "Üyeler birbirinin hedeflerini görsün",
  gs_members_see_goals_desc:
    "Açıkken üyeler Gruplarım sıralamasında birbirinin grup hedeflerindeki ilerlemesini görür. Kişisel hedefler görünmez.",
  gs_edit_title: "Geçmiş günleri düzenleme",
  gs_edit_question: "Üyeler kaç gün geriye kadar kayıt girebilir?",
  gs_edit_today_only: "Yalnız bugün",
  gs_edit_days: "{n} gün",
  gs_edit_unit: "gün",
  gs_edit_decrease: "Bir gün azalt",
  gs_edit_increase: "Bir gün artır",
  gs_edit_hint: "Birden çok gruptaki üye için en esnek sınır geçerli olur.",
  gs_save: "Kaydet",
  gs_saved: "Ayarlar kaydedildi.",
  gs_save_error: "Ayarlar kaydedilemedi.",
  gs_load_error: "Ayarlar yüklenemedi.",
  gs_retry: "Tekrar dene",
  edit_window_locked: "Yalnızca son {days} günün kaydı düzenlenebilir.",
  edit_window_locked_today: "Yalnızca bugünün kaydı düzenlenebilir.",
};

export default latin;
